import localforage from 'localforage'

const CACHE_TTL_MS = 24 * 60 * 60 * 1000

const baseConfig = {
  name: 'sunbold-crm-cache'
}

const galleryStore = localforage.createInstance({
  ...baseConfig,
  storeName: 'gallery'
})

const projectsStore = localforage.createInstance({
  ...baseConfig,
  storeName: 'projects'
})

const makeEntry = value => ({
  value,
  cachedAt: Date.now()
})

const readEntry = async (store, key) => {
  const entry = await store.getItem(key)

  if (!entry || typeof entry !== 'object') {
    return { value: null, cachedAt: null, isFresh: false }
  }

  const cachedAt = typeof entry.cachedAt === 'number' ? entry.cachedAt : null
  const isFresh = cachedAt ? Date.now() - cachedAt <= CACHE_TTL_MS : false

  return {
    value: entry.value ?? null,
    cachedAt,
    isFresh
  }
}

const writeEntry = (store, key, value) => store.setItem(key, makeEntry(value))

export const cacheKeys = {
  galleryList: 'gallery:list:v1',
  projectsHeader: 'projects:header:v1',
  projectsPosts: 'projects:posts:v1'
}

export const galleryCache = {
  readList() {
    return readEntry(galleryStore, cacheKeys.galleryList)
  },
  writeList(value) {
    return writeEntry(galleryStore, cacheKeys.galleryList, value)
  },
  clearList() {
    return galleryStore.removeItem(cacheKeys.galleryList)
  }
}

export const projectsCache = {
  readHeader() {
    return readEntry(projectsStore, cacheKeys.projectsHeader)
  },
  writeHeader(value) {
    return writeEntry(projectsStore, cacheKeys.projectsHeader, value)
  },
  readPosts() {
    return readEntry(projectsStore, cacheKeys.projectsPosts)
  },
  writePosts(value) {
    return writeEntry(projectsStore, cacheKeys.projectsPosts, value)
  },
  clearAll() {
    return Promise.all([
      projectsStore.removeItem(cacheKeys.projectsHeader),
      projectsStore.removeItem(cacheKeys.projectsPosts)
    ])
  }
}

export { CACHE_TTL_MS }
